module.exports = "../static/media/icon_famale.df6cfa83.png";